// extracted by mini-css-extract-plugin
export const root = "post-item-module--root--2RR7d";
export const meta = "post-item-module--meta--18yaI";
export const title = "post-item-module--title--3kFj1";